import { css } from '@emotion/react';
import React from 'react';
import { SignInForm } from './forms/SignInForm';

export const LoginScreen = () => {
	return (
		<div
			css={css`
				display: flex;
				height: 100%;
				align-items: center;
				justify-content: center;
				overflow: auto;
			`}
		>
			<SignInForm />
		</div>
	);
};
